import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

export const useIsTabletView = () => {
  const theme = useTheme();
  const isTabletView = useMediaQuery(theme.breakpoints.down('md'));
  return isTabletView;
};
